import React, { Fragment, useMemo } from "react";
import { Alert, Skeleton, Spin } from "antd";
import { useLocation, useParams } from "react-router-dom";
import { DefaultEntityDescription, DefaultEntityDescriptionProps } from "../../components/crud/defaultEntityDescription";
interface DefaultEntityDetailProps extends DefaultEntityDescriptionProps {
  query: Function;
  customContent?: (entity: any) => React.ReactElement;
  customExtraContent?: (entity: any) => React.ReactNode;
}

const DefaultEntityDetail = React.memo(({ query, fields, presenter, customContent, customExtraContent, itemStyle }: DefaultEntityDetailProps) => {
  const params = useParams();
  const entityId = params.recordId ? params.recordId : 0;
  const location = useLocation();

  const locationState = useMemo(() => location.state as any, [location.state]);

  const { data, isFetching } = query(entityId);

  const entity = useMemo(() => data ?? locationState?.record ?? null, [data, locationState]);

  return (
    <Spin spinning={isFetching}>
      {entity ? (
        <Fragment>
          {customContent ? (
            <div>{customContent(entity)}</div>
          ) : (
            <DefaultEntityDescription entity={entity} fields={fields} presenter={presenter} itemStyle={itemStyle} />
          )}
          {customExtraContent && <div className="mt-4">{customExtraContent(entity)}</div>}
        </Fragment>
      ) : isFetching ? (
        <Skeleton active />
      ) : (
        <Alert type="warning" className="lg:w-1/2" message="رکورد مورد نظر پیدا نشد!" />
      )}
    </Spin>
  );
});

export const GetDefaultEntityDetail =
  ({ query, fields, presenter, customContent, customExtraContent, itemStyle }: DefaultEntityDetailProps) =>
  () =>
    <DefaultEntityDetail query={query} fields={fields} presenter={presenter} customContent={customContent} customExtraContent={customExtraContent} itemStyle={itemStyle} />;
